<template>
  <div class="nav">
    <div class="title-box">
      <el-row>
        <el-col :span="12">
          <router-link :to="'/'">
            <img src="../../../assets/images/zsLogo.png" class="grid-content" v-if="showQuDao"/>
            <img src="../../../assets/images/qxLogo.png" style="margin-top: 0;" class="grid-content" v-else/>
          </router-link>
        </el-col>
        <el-col :span="12">
          <ul class="menu-title clear">
            <li style="font-size: 16px;color: #333" @click="newGuide">
              新手指引
            </li>
            <li style="font-size: 16px" v-if="showQuDao">
              <router-link :to="'/task-wall'">
                <el-badge is-dot class="item">任务墙</el-badge>
              </router-link>
            </li>
            <li @click="showMessage" style="font-size: 16px;color: #333" v-if="showQuDao">
              建议
            </li>
            <li v-if="showQuDao">
              <el-popover
                popper-class="chart-po"
                width="102"
                trigger="hover">
                <div class="chart-box-po pr">
                  <!-- 正在开发中... -->
                  <img src="../../../assets/images/xcx.jpg" alt="">
                </div>
                <img slot="reference" src="../../../assets/images/icon_web.png"/>
              </el-popover>
            </li>
            <!-- <li @click="dialogVisible = true">
              <img src="../../../assets/images/icon_s.png"/>
            </li> -->
            <li v-if="showQuDao">
              <router-link :to="'/common-problem'">
                <img src="../../../assets/images/icon_mark.png"/>
              </router-link>
            </li>
            <li v-if="showQuDao">
              <el-popover
                popper-class="message-po"
                width="274"
                trigger="hover">
                <div class="message-box-po pr">
                  <div class="message-top clear">
                    <div class="fl pr" :class="[isTag ? 'active': '']" @click="show">通知({{pagination.totalRows}})</div>
                    <!--<div class="fr pr" :class="[!isTag ? 'active': '']" @click="show">待办({{noReadList.length}})</div>-->
                  </div>
                  <div class="my-scrollbar-message" ref="scrollbar">
                    <ul class="notice" v-if="isTag">
                      <li class="pr" v-for="item in temReadList" :key="$index">
                        <div class="box pa"><i class="el-icon-message"></i></div>
                        <p><router-link :to="'/message-center'">{{item.title}}</router-link></p>
                        <span>{{formatTime(item.createTime)}}</span>
                      </li>
                    </ul>
                    <div class="no-more">
                      <span v-if="noMore">没有更多了...</span>
                    </div>
                  </div>
                  <div class="message-bt">
                    <router-link :to="'/message-center'">
                      <p>消息中心</p>
                    </router-link>
                    <p class="clear-wait" v-if="false">清空待办</p>
                  </div>
                </div>
                <el-badge slot="reference" :value="pagination.totalRows" :max="99" class="item" v-if="this.temReadList.length === 0" hidden>
                  <img src="../../../assets/images/icon_bell.png" alt="">
                </el-badge>
                <el-badge slot="reference" :value="pagination.totalRows" :max="99" class="item"  v-else>
                  <img src="../../../assets/images/icon_bell.png" alt="">
                </el-badge>
              </el-popover>
            </li>
            <li>
              <el-popover
                popper-class="wallet-po"
                trigger="hover">
                <div class="wallet-box">
                  <div class="wallet-box-tp" v-if="showQuDao">
                    <router-link :to="'/channel-credit'">
                      <img src="../../../assets/images/back/nav/wallet.png" alt="">
                      <span>您的积分：{{score.currentScore}}</span>
                    </router-link>
                  </div>
                  <div class="wallet-box-bt clear">
                    <ul class="fl">
                      <li>
                        <router-link :to="'/balance-center'">
                          <img src="../../../assets/images/back/nav/ye.png" alt="">
                          <span>余额</span>
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="'/payment-record'">
                          <img src="../../../assets/images/back/nav/jl.png" alt="">
                          <span>充值记录</span>
                        </router-link>
                      </li>
                    </ul>
                    <ul class="fl">
                      <li>
                        <router-link :to="'/expenses-record'">
                          <img src="../../../assets/images/back/nav/list.png" alt="">
                          <span>消费报表</span>
                        </router-link>
                      </li>
                      <li v-if="showQuDao">
                        <router-link :to="'/my-order'">
                          <img src="../../../assets/images/back/nav/dd.png" alt="">
                          <span>商城订单</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
                <img slot="reference" src="../../../assets/images/icon_wallet.png"/>
              </el-popover>
            </li>
            <li>
              <el-popover
                popper-class="user-po"
                width="105"
                trigger="hover">
                <div class="user-box-po">
                  <ul>
                    <li>
                      <router-link :to="'/account-info'">
                        <img src="../../../assets/images/back/nav/zh.png" alt="">
                        <span>账户信息</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="'/change-password'">
                        <img src="../../../assets/images/back/nav/mm.png" alt="">
                        <span>修改密码</span>
                      </router-link>
                    </li>
                    <li v-if="showQuDao">
                      <router-link :to="'/shop-address'">
                        <img src="../../../assets/images/back/nav/sh.png" alt="">
                        <span>收货地址</span>
                      </router-link>
                    </li>
                    <li @click="loginOut">
                      <img src="../../../assets/images/back/nav/tc.png" alt="">
                      <span>退出</span>
                    </li>
                  </ul>
                </div>
                <div class="user-avatar" slot="reference">
                  <template v-if="userInfo.info && userInfo.info.thumbnail !== '' && userInfo.info.thumbnail !== undefined">
                    <img :src="userInfo.info.thumbnail">
                  </template>
                  <template v-else>
                    <img src="../../../assets/images/icon_user.png">
                  </template>
                </div>
              </el-popover>
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <Message :visible.sync="showDialog"></Message>
    <el-dialog
      class="dia-title"
      title="填写信息让您的专属客服帮您"
      :visible.sync="dialogVisible"
      center
      width="690px"
      height="460px">
      <div class="message">
        <el-form :model="form" ref="formModifyRow" :rules="rules">
          <el-form-item :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}" prop="enterpriseName">
            <el-input
              v-model="form.enterpriseName"
              placeholder="企业名称（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}">
            <el-input
              v-model="form.name"
              placeholder="姓名（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确'}]">
            <el-input
              v-model="form.telephone"
              placeholder="联系电话（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="message-btn"  @click="submitRow()">立即提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Api from '@/api/system/user'
  import scoreApi from '@/api/client/task-wall'
  import Message from '@/components/client/Message'
  import { FormArgument } from '@/models/customer-good'
  import moment from 'moment'
  import 'moment/locale/zh-cn'

  export default {
    name: 'ms-nav',
    components: {
      Message
    },
    data () {
      return {
        showQuDao: true,
        score: [],
        isTag: true,
        messageList: [],
        noReadList: [],
        temReadList: [],
        pagination: {},
        showDialog: false,
        dialogVisible: false,
        form: new FormArgument(),
        activeName: 'first',
        page: 1,
        pages: 0,
        noMore: false
      }
    },
    created () {
      if (window.location.host !== 'test-emcp.qudao51.com' && window.location.host !== 'www.qudao51.com') {
        this.showQuDao = false
      }
      if (window.location.host === 'localhost:8030') {
        this.showQuDao = true
      }
      this.requestList()

      let id = null
      Api.getInfo(response => {
        let status = response.data.code
        let body = response.data.data || {}
        if (status === '200') {
          id = body.id
          this.requireStomp(id)
          this.getUserNotReadMsg(id, this.page)
          this.getUserAllMsg(id, this.page)
        }
      })
    },
    watch: {
      noReadList () {
        this.temReadList = []
        this.noReadList.forEach(item => {
          this.temReadList.push(item)
        })
        return this.temReadList
      }
    },
    computed: {
      userInfo () {
        return this.$store.state.user.info || {}
      }
    },
    methods: {
      requireStomp (id) {
        this.$stompClient.connect({}, frame => {
          // this.$stompClient.subscribe('/system/notifications', message => {
          //   let info = JSON.parse(message.body || '{}')
          //   this.messageList = info.list
          //   // console.log(' 用户全部信息', info)
          // })
          // 订阅系统通知
          this.$stompClient.subscribe('/system/notifications', message => {
            const msg = JSON.parse(message.body || '{}')
            this.noReadList.unshift(msg)
            this.pagination.totalRows++
            this.$store.dispatch('receiveSystemNotice')
            this.$notify.info({
              title: msg.title,
              message: msg.contents || '暂无消息内容'
            })
          })
          this.$stompClient.subscribe('/user/' + id + '/notifications', message => {
            console.log(id)
            let info = JSON.parse(message.body || '{}')
            this.messageList = info.list
            // console.log(' 用户全部信息', info)
          })
          // 未读信息
          this.$stompClient.subscribe('/user/' + id + '/not/notifications', message => {
            console.log(id)
            let info = JSON.parse(message.body || '{}')
            this.noReadList = info.list
            this.pagination = info.pageInfo
            this.pages = info.pageInfo.totalRows
            // console.log(' 用户未读信息', info)
          })
          this.$stompClient.send('/app/example.myself', JSON.stringify({'targetId': id}))
        })
      },
      show () {
        this.isTag = !this.isTag
      },
      getUserAllMsg (userId, page) {
        let message = {targetGenre: 'customer', targetId: userId, message: '123', page: page, pageSize: 5}
        Api.getUserAllMsg({message}, response => {
          let status = response.status
          if (status === 200 || status === 204) {
          }
        })
      },
      getUserNotReadMsg (userId, page) {
        let message = {targetGenre: 'customer', targetId: userId, message: '123', page: page, pageSize: 5}
        Api.getUserNotReadMsg({message}, response => {
          let status = response.data.code
          if (status === '200') {
            let info = response.data.data
            this.noReadList = info.list
            this.pagination = info.pageInfo
            this.pages = info.pageInfo.totalRows
          }
        })
      },
      loginOut () {
        Api.logout(response => {
          let status = response.data.code
          let body = response.data.data || {}
          if (status === '200') {
            this.$store.dispatch('logout')
            this.$cookie.delete('_qd_emcp.l_s')
            this.$router.push('/')
            this.$message.success('您已退出登录！')
          } else {
            this.$message.error(response.data.msg || '登出失败')
          }
        })
      },
      submitRow () {
        this.$refs['formModifyRow'].validate((valid) => {
          if (valid) {
            let name = this.form.name
            let enter = this.form.enterpriseName
            let phone = this.form.telephone
            if (name !== '' && name !== undefined && enter !== '' && enter !== undefined && phone !== '' && phone !== undefined) {
              let form = this.form
              form.type = 9
              form.platform = 2
              Api.create({form: form}, response => {
                let status = response.status || 0
                let body = response.data || []
                if (status >= 200 && status <= 204) {
                  // 新数据加到数组开头
//                  this.message.unshift(body)
                  this.$message.success('留言成功')
                } else {
                  this.$message.error(body.error || '留言失败')
                }
                // 关闭
                this.$refs['slideModifyRow'].close()
              })
              this.form = []
              this.dialogVisible = false
            } else {
              this.$message.error('信息不能为空')
            }
          } else {
            return false
          }
          this.form = []
        })
      },
      requestList () {
        scoreApi.scoreList(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.score = body
          } else {
            this.score = []
          }
        })
      },
      formatTime (val) {
        // return moment(val, 'YYYY-MM-DD hh:mm:ss').format('MM')
        return moment(val).fromNow()
      },
      showMessage () {
        this.showDialog = true
      },
      newGuide () {
        this.$emit('showNewGuideHandler')
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  @import '../../../assets/styles/_env.scss';

  .nav {
    .dia-title{
      .message {
        padding: 45px 130px;
        box-sizing: border-box;
        .message-inp {
          width: 380px;
          height: 40px;
        }
        .message-btn {
          width: 180px !important;
          height: 40px !important;
          margin-left: 28%;
          background: #085ECC;
          &:hover{
            background: #4a98ff;
            transition-duration: 0.5s;
          }
        }
      }
    }
    .title-box {
      width: 1400px;
      height: 60px;
      line-height: 60px;
      margin: 0 auto;
      padding: 0 20px;
      box-sizing: border-box;
      .grid-content {
        width: 160px;
        // height: 40px;
        margin-top: 10px;
      }
      .menu-title {
        list-style: none;
        position: relative;
        margin-left:60px;
        float:right;
        padding-right:20px;
        box-sizing: border-box;
        &:hover {
          cursor: pointer;
        }
        a {
          text-decoration: none;
          display: block;
          text-align: center;
          color: #333;
        }
        > li {
          float: left;
          margin-right: 40px;
          &:hover {
            cursor: pointer;
          }
          &:last-child{
            margin-right:0;
          }
          img {
            vertical-align: middle;
          }
          .item {
            > .el-badge__content {
              position: absolute;
              top: 20px;
            }
          }
        }
        .user-avatar {
          width: 32px;
          height: 32px;
          margin-top: 14px;
          border-radius: 50%;
          overflow: hidden;
          background: #f5f5f5;
          >img{
            width: 100%;
            height: 100%;
            vertical-align: top;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .menu-title {
    .el-badge{
      font-size: 16px;
      margin-top: -1px;
    }
    .el-badge__content.is-fixed {
      top: 16px;
    }
  }

  body {
    .wallet-po {
      padding: 0;
      width: 235px;
    }
    .chart-po {
      padding: 0;
      height: 102px;
      border-radius: 50%;
      min-width: 102px;
    }
    .user-po {
      min-width: 129px;
      padding: 9px 11px 1px;
    }
    .message-po {
      padding: 20px 0 5px;
      .my-scrollbar-message {
        height: 225px;
        overflow-y: scroll;
        margin-bottom: 10px;
        .no-more {
          text-align: center;
          color: #999999;
          font-size: 12px;
        }
      }
    }
  }

  .wallet-box {
    background: white;
    &-tp {
      background: #2c80e5;
      text-align: center;
      height: 40px;
      line-height: 40px;
      a {
        color: white;
      }
      img {
        vertical-align: middle
      }
      span {
        vertical-align: middle;
      }
    }
    &-bt {
      color: #666666;
      padding: 20px 24px 28px;
      ul {
        &:first-child {
          margin-right: 40px;
        }
        li {
          img {
            vertical-align: middle
          }
          span {
            vertical-align: middle;
            color: #666666;
          }
          &:first-child {
            margin-bottom: 25px;
          }
        }
      }
    }
  }

  .user-box-po {
    margin: 5px 0 0 20px;
    ul {
      li {
        cursor: pointer;
        margin-bottom: 18px;
        img {
          vertical-align: middle;
          margin-right: 5px;
        }
        span {
          vertical-align: middle;
          color: #666666;
        }
      }
    }
  }

  .chart-box-po {
    overflow: hidden;
    height: 102px;
    line-height: 102px;
    text-align: center;
    > img {
      width:100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .message-box-po {
    .message-top {
      padding: 0 60px;
      box-sizing: border-box;
      height: 56px;
      > div {
        height: 30px;
        cursor: pointer;
        font-size: 15px;
      }
      .active {
        position: relative;
        color: #2c80e5;
        border-bottom: 2px solid #2c80e5;
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          border-bottom: 5px solid #2c80e5;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
        }
      }
    }
    ul {
      padding-left: 55px;
      li {
        margin-bottom: 17px;
        .box {
          width: 32px;
          height: 32px;
          background: #9ddede;
          border-radius: 50%;
          left: -45px;
          top: 5px;
          text-align:center;
          i{
            color:#fff;
            font-size:17px;
            margin-top:7px;
          }
        }
        p {
          margin: 0;
          a{
            color:#085ECC;
          }
        }
        span {
          color: #999999;
        }
      }
    }
    .message-bt {
      text-align: center;
      font-size: 12px;
      p {
        color: #fff;
        cursor: pointer;
        width: 250px;
        height: 28px;
        margin: 0 auto;
        line-height: 28px;
        background: #085ecc;
        border-radius: 4px;
        margin-bottom: 9px;
      }
      .clear-wait {
        background: #F87E8C;
        color: white;
      }
    }
  }

  .small-pagination {
    text-align: center;
    .el-pager {
      padding: 0;
      li {
        margin-bottom: 0;
      }
    }
  }
</style>
<style>
  .nav > .dia-title > .el-dialog >.el-dialog__header{
    height: 70px;
    line-height: 70px;
    background: #f9f9f9;
  }
  .nav > .dia-title > .el-dialog >.el-dialog__header > .el-dialog__title{
    color: #085ECC;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/common/NavHome.vue